module.exports = __webpack_public_path__ + "static/img/img-background-4.41530ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-4.jpg
// module id = 1H7P
// module chunks = 36